// © 2026 AttainIP Engineering
/**
 * Skip-to-content link — WCAG 2.1 AA (2.4.1 Bypass Blocks)
 *
 * Visually hidden until focused via keyboard. Jumps past header/nav
 * straight to the main content area.
 */

export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:text-sm focus:font-medium focus:outline-none focus:ring-2 focus:ring-ring"
    >
      Skip to content
    </a>
  );
}
